<template>
  <div
    v-if="!userDisabled(identifier) && flashcard"
    class="question-of-the-day-container"
  >
    <dashboard-widget-header
      :title="'Question of the Day'"
      :subtitle="subTitle"
      :show-close="userHideable"
      @remove-requested="removeRequested(identifier)"
    />
    <button
      v-if="!loading && question"
      class="gradient-wrapper"
      aria-label="Question of the day"
      @click="goToView"
    >
      <div class="question-wrapper">
        <p
          class="question"
        >
          {{ question }}
        </p>
        <div class="question-state">
          <icon
            v-if="!wasAnsweredToday || !flashcardState"
            class="state-icon"
            name="circle-outline"
            variant="000000"
          />
          <template v-else>
            <icon
              v-if="flashcardState.correct"
              class="state-icon"
              name="check-filled"
              variant="00B46D"
            />
            <icon
              v-else
              class="state-icon"
              name="cross-filled"
              variant="DC3416"
            />
          </template>
        </div>
      </div>
    </button>
  </div>
</template>

<script>
import DashboardWidgetHeader from '@components/dashboard-widgets/header';
import Icon from '@components/singletons/icon';

import GlobalMixin from '@/mixins/global';
import WidgetMixin from '@/mixins/widget';
import QuestionUIV2Mixin from '@/mixins/questions-ui-v2';

import { stripHtml } from '@/utils';

import { isSameDay } from 'date-fns';

export default {
  components: { DashboardWidgetHeader, Icon },
  mixins: [GlobalMixin, WidgetMixin, QuestionUIV2Mixin],
  props: {
    dashboard: {
      type: Object,
    },
    config: {
      type: Object,
    },
    identifier: {
      type: Number,
    },
    userHideable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      categoryId: '',
      flashcardId: '',
      loading: false,
    };
  },
  computed: {
    flashcard() {
      if (this.flashcardId) {
        return this.$store.getters['flashcards/flashcards'][this.flashcardId] || {};
      }
    },
    flashcardState() {
      if (this.flashcardId && this.categoryId) {
        return this.$store.getters['flashcardStates/flashcardStates'][`${this.flashcardId}-category-${this.categoryId}`];
      }
    },
    question() {
      return this.stripHtml(this.flashcard?.question);
    },
    subTitle() {
      return 'Next question drops at 10 p.m. EST';
    },
    wasAnsweredToday() {
      if (this.flashcardState?.mobileCreatedAt) {
        return isSameDay(this.flashcardState.mobileCreatedAt, new Date());
      }
      return false;
    },
  },
  async mounted() {
    this.loading = true;
    const data = await this.$store.dispatch('flashcards/fetchQuestionOfTheDay');
    this.flashcardId = data.flashcard?.id;
    this.categoryId = data.categoryId;
    this.loading = false;
  },
  methods: {
    goToView() {
      const params = {
        state: !!(this.wasAnsweredToday && this.flashcardState) ? 'Answered' : 'Unanswered',
        dashboardId: this.dashboard.id,
        widgetTitle: 'Question of the Day',
        assetId: this.flashcard.id,
      };
      this.$analytics.events.selectedQOTDWidget(params);
      if (this.questionUiV2Enabled) {
        return this.$router.push({
          name: 'qotd#flashcard-v2',
          params: {
            categoryId: this.categoryId,
            flashcardId: this.flashcard?.id,
          },
        });
      }
      return this.$router.push({
        name: 'qotd#index',
        params: {
          categoryId: this.categoryId,
          flashcardId: this.flashcard?.id,
        },
      });
    },
    stripHtml,
  },
};
</script>

<style lang='scss' scoped>
.question-of-the-day-container {
  padding: rem-calc(20) 0;

  :deep(.dashboard-widget-header) {
    margin-bottom: rem-calc(12);
  }
  .gradient-wrapper {
    display: flex;
    padding: 4px;
    background: linear-gradient(270.17deg, #00D8F8 0.12%, #7EEEFF 99.83%);
    border-radius: 4px;
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.15);

    .question-wrapper {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      text-align: left;
      background: #FFFFFF;
      padding: 1rem;
      border-radius: 2px;

      .question {
        display: -webkit-box;
        width: 93%;
        font-size: rem-calc(14);
        line-height: rem-calc(20);
        margin: 0;
        overflow: hidden;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 4;
      }
      .question-state {
        .state-icon {
          height: rem-calc(20);
          width: rem-calc(20);
        }
      }
    }
  }
}
</style>
